import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import navigationConfig, {
  mechanicNavigationConfig,
} from "configs/NavigationConfig";

export const mapApiToRole = (apiRole) => {
  if (!apiRole) return null;

  const roleMap = {
    DRIVER: "driver",
    SERVICE_PROVIDER: "mechanic",
    FLEET_MANAGER: "fleet_manager",
    OWNER: "truck_owner",
  };

  return roleMap[apiRole] || apiRole.toLowerCase();
};

export const ROLES = {
  SERVICE_PROVIDER: "SERVICE_PROVIDER",
  OWNER: "OWNER",
  DRIVER: "DRIVER",
  FLEET_MANAGER: "FLEET_MANAGER",
};

export const getDashboardPath = (role) => {
  const dashboardMap = {
    truck_owner: `${APP_PREFIX_PATH}/truck_owner/home`,
    mechanic: `${APP_PREFIX_PATH}/mechanic/dashboard`,
    fleet_manager: `${APP_PREFIX_PATH}/fleet-dashboard/home`,
    driver: `${APP_PREFIX_PATH}/driver/home`,
  };

  return dashboardMap[role] || `${APP_PREFIX_PATH}/fleet-dashboard/home`;
};

export const getNavigationConfig = (role) => {
  const navConfigMap = {
    mechanic: mechanicNavigationConfig,
    truck_owner: navigationConfig,
    fleet_manager: navigationConfig,
    driver: navigationConfig,
  };

  return navConfigMap[role] || navigationConfig;
};

export const requiresVerification = (role) => {
  return role === "truck_owner" || role === "fleet_manager";
};

export const canAccessRoute = (userRole, allowedRoles = []) => {
  // If no roles specified, anyone can access
  if (allowedRoles.length === 0) return true;

  // Check if user's role is in allowed roles
  return allowedRoles.includes(userRole);
};

// ==================== DocuSign carrier onboarding agreement ====================
// Mirrors the app (src/utils/constants.jsx). Keep in sync with the backend
// feature. Flipping ENABLE_ONBOARDING_AGREEMENT to false disables the gate.
export const ENABLE_ONBOARDING_AGREEMENT = true;

// Raw backend roles that must sign the carrier onboarding agreement during
// signup. DRIVER is excluded (drivers are created by a fleet manager and only
// log in). ADMIN is never gated.
export const ONBOARDING_AGREEMENT_ROLES = [
  ROLES.OWNER,
  ROLES.SERVICE_PROVIDER,
  ROLES.FLEET_MANAGER,
];

// Route the DocuSign agreement is signed on.
export const ONBOARDING_AGREEMENT_PATH = `${AUTH_PREFIX_PATH}/onboarding-agreement`;

// True when the given user still has to sign the onboarding agreement. Reads
// the raw `role`/`onboardingAgreement` off the user object (same shape the app
// checks), so it works with userData from login / auth-me alike.
export const needsOnboardingAgreement = (userData) =>
  ENABLE_ONBOARDING_AGREEMENT &&
  !!userData &&
  ONBOARDING_AGREEMENT_ROLES.includes(userData?.role) &&
  userData?.onboardingAgreement?.status !== "completed";

export const getRoleDisplayName = (role) => {
  const displayNames = {
    truck_owner: "Truck Owner",
    mechanic: "Mechanic",
    fleet_manager: "Fleet Manager",
    driver: "Driver",
  };

  return displayNames[role] || "User";
};

export default {
  mapApiToRole,
  getDashboardPath,
  getNavigationConfig,
  requiresVerification,
  canAccessRoute,
  getRoleDisplayName,
  ROLES,
};
